module.exports = __webpack_public_path__ + "svg/new-mobilepay-big.ecd060f5fc96adb662aa7cac0bf4f576.svg";